import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TodayTrend from "../api/TodayTrend";
import play from "../image/play.png";
import { Typography, Skeleton, Box } from "@mui/material";

const BANNER_HEIGHT = '50vh';

const Slider1 = () => {
  const [featured, setFeatured] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const controller = new AbortController();
    TodayTrend({ signal: controller.signal })
      .then((response) => {
        const first = response.data?.results?.find(
          (item) => item.media_type === 'movie'
        );
        if (first) setFeatured(first);
      })
      .catch((err) => {
        if (err?.name === 'CanceledError' || err?.name === 'AbortError') return;
        setError("Could not load featured content.");
      });
    return () => controller.abort();
  }, []);

  if (error) {
    return <div role="alert">{error}</div>;
  }

  if (!featured) {
    return (
      <Box
        className="SliderH"
        sx={{
          position: 'relative',
          width: '100%',
          height: BANNER_HEIGHT,
          bgcolor: '#1a1a1a',
          overflow: 'hidden',
        }}
      >
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{ bgcolor: '#2A2A2B' }}
          animation="wave"
        />
      </Box>
    );
  }

  const title = featured.title || featured.original_name || 'Featured movie';

  const handlePlay = () => {
    navigate(`/movie/${featured.id}`);
  };

  return (
    <Box
      className="SliderH"
      sx={{
        position: 'relative',
        width: '100%',
        height: BANNER_HEIGHT,
        overflow: 'hidden',
        color: 'white',
      }}
    >
      <img
        src={`https://image.tmdb.org/t/p/w1280${featured.backdrop_path}`}
        alt={`Featured: ${title}`}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
          display: 'block',
        }}
      />
      <div className="bannertext">
        <Typography variant="h4" component="h2" sx={{ color: '#fff', fontWeight: 700 }}>
          {title}
        </Typography>
        <div className="play">
          <button
            onClick={handlePlay}
            aria-label={`Open details for ${title}`}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              minHeight: 44,
            }}
          >
            <img src={play} alt="" aria-hidden="true" />
            <Typography variant="h6" ml={1} style={{ color: 'white' }}>
              Watch Now
            </Typography>
          </button>
        </div>
      </div>
    </Box>
  );
};

export default Slider1;
